export default __webpack_public_path__ + "static/media/stable-swap-icon.acf72025.png";